/**
 *
 * @constructor
 */
function FacebookAuthenticationController() {

    this.$facebookAuthObject = $('.facebookLogin');
}

FacebookAuthenticationController.prototype.init = function () {
    this.loadFacebookSdk();
};

FacebookAuthenticationController.prototype.loadFacebookSdk = function () {
    console.log('load_facebook_sdk');
    var that = this;
    window.fbAsyncInit = function() {

        FB.init({
            appId      : '494691101002026',
            cookie     : true,
            xfbml      : true,
            version    : 'v3.1'
        });

        that.handleFacebookAuthClickEvent();

    };

    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
};

FacebookAuthenticationController.prototype.handleFacebookAuthClickEvent = function () {
    var that = this;
    this.$facebookAuthObject.on('click', function () {

        FB.login(function(response) {
            if (response.status === 'connected') {
                that.statusChangeCallback(response);
            } else {
                that.statusChangeCallback(response);
            }
        }, {scope: 'email, public_profile'});

    });
};

FacebookAuthenticationController.prototype.checkUserStatus = function () {
    var that = this;
    FB.getLoginStatus(function(response) {
        console.log(response);
        that.statusChangeCallback(response);
    });
};

FacebookAuthenticationController.prototype.statusChangeCallback = function (response) {

    if (response.status && response.status === 'connected') {
        this.finishOauth(response);
    } else {
        console.log('please_log_in');
    }
};

FacebookAuthenticationController.prototype.finishOauth = function (LoginResponse) {


    FB.api('/me', 'get', {fields: 'id,name,first_name, email'}, function(response) {
        // registration error
        if(response.error) {
            console.log('error', response.error);
            return;
        }

        let registrationInfo = {
            lname: '',
            fname: response.first_name,
            email: response.email,
            password: LoginResponse.authResponse.userID,
            withtoken: 0,
            withoutlname: 1,
            logintype: 2,
            clientid:  LoginResponse.authResponse.userID,
            authobj: JSON.stringify(LoginResponse.authResponse),
            aszfon: true,
            withtoken: true,
        };

        try {
            registrationInfo = JSON.stringify(registrationInfo);
        }catch (err) {
            registrationInfo = {fname: null}
        }

        sessionStorage.setItem('RegistrationInfo', registrationInfo);

        try {
            grecaptcha.execute();
        }catch (err) {

        }
    });



};

module.exports = FacebookAuthenticationController;